module.exports = __webpack_public_path__ + "img/videos.06e683f5.svg";